import { CDN_BASE_URL } from './cdn';
export const ASSETS = {
    heroNYNG: `${CDN_BASE_URL}/heroNYNG.png`,
    balloonCutouts: `${CDN_BASE_URL}/balloonCutouts.png`,
    logoIgdb: `${CDN_BASE_URL}/logoIgdb.png`,
    logoTwitch: `${CDN_BASE_URL}/logoTwitch.png`,
    logoApex3: `${CDN_BASE_URL}/logoApex3.png`,
    logoPoppyYT2x: `${CDN_BASE_URL}/logoPoppy-YT2x.png`,
    ogImage: `${CDN_BASE_URL}/og-image-v2.png`,
    coverFinishEachOthersSandwiches: `${CDN_BASE_URL}/cover-FEOS.png`,
    coverEgoManiacs: `${CDN_BASE_URL}/cover-EgoManiacs.png`,
    coverMemeMash: `${CDN_BASE_URL}/cover-MemeMash.png`,
    coverWTFIsHappening: `${CDN_BASE_URL}/cover-WTF.png`,
    coverSecondOpinions: `${CDN_BASE_URL}/cover-SecondOpinions.png`,
    coverQuinspire: `${CDN_BASE_URL}/cover-Quinspire.png`,
    coverTooManyCooks: `${CDN_BASE_URL}/cover-TooManyCooks2.png`,
    coverBadBunnies: `${CDN_BASE_URL}/cover-BadBunnies.png`,
    coverFeedTheFarm: `${CDN_BASE_URL}/cover-FeedTheFarm.png`,
    coverOkieDokie: `${CDN_BASE_URL}/cover-okie-dokie.png`,
    coverWanted: `${CDN_BASE_URL}/cover-wanted3.png`,
    coverWildThings: `${CDN_BASE_URL}/cover-wild-things.png`,
    blogWildThingsDave: `${CDN_BASE_URL}/blog-wild-things-dave.png`,
    blogWantedMermaidPoster: `${CDN_BASE_URL}/blog-wanted-mermaid-poster.png`,
    twitchExplosion: `${CDN_BASE_URL}/twitchExplosion.png`,
    twitchLive: `${CDN_BASE_URL}/twitchLive.png`,
    blogDiscover: `${CDN_BASE_URL}/blogDiscover.png`,
    blogPartyCentral: `${CDN_BASE_URL}/blogPartyCentral.png`,
    featureLogin: `${CDN_BASE_URL}/feature-login2.png`,
    featureLibrary: `${CDN_BASE_URL}/feature-library.png`,
    featureConnectTwitch: `${CDN_BASE_URL}/feature-connectTwitch.png`,
    featureConnections: `${CDN_BASE_URL}/feature-connections.png`,
    featureEmailOtp: `${CDN_BASE_URL}/feature-emailOTP2.png`,
    featureSelectGame: `${CDN_BASE_URL}/feature-selectGame2.png`,
    featurePlayerStandard: `${CDN_BASE_URL}/feature-playerStandard2.png`,
    featurePlayerTwitch: `${CDN_BASE_URL}/feature-playerTwitch2.png`,
    featureRoomStart: `${CDN_BASE_URL}/feature-minPlayers2.png`,
    featureSkipIntro: `${CDN_BASE_URL}/feature-skipIntro2.png`,
    featureLiveDiscord: `${CDN_BASE_URL}/feature-liveDiscord.png`,
    featureLivePill: `${CDN_BASE_URL}/feature-livePill2.png`,
    featureClipsLibrary: `${CDN_BASE_URL}/feature-clipsLibrary2.png`,
    featureHostStyle3: `${CDN_BASE_URL}/feature-hostStyle3.png`,
    blogPoppyPunchy: `${CDN_BASE_URL}/blogPoppyPunchy.png`,
    featureModToolsSidebar: `${CDN_BASE_URL}/feature-modToolsSidebar2.png`,
    featurePitcMenu: `${CDN_BASE_URL}/feature-pitcMenu.png`,
    featurePitcChat: `${CDN_BASE_URL}/feature-pitcChat.png`,
    featureCustomProfanity: `${CDN_BASE_URL}/feature-customProfanity2.png`,
    featureVolumeSliders: `${CDN_BASE_URL}/feature-volumeSliders3.png`,
    featurePoppyMuted: `${CDN_BASE_URL}/feature-poppyMuted2.png`,
    featureMusicDisplay: `${CDN_BASE_URL}/feature-musicDisplay2.png`,
    featurePoppyPfp: `${CDN_BASE_URL}/feature-poppyStandard.png`,
    featurePoppyHover: `${CDN_BASE_URL}/feature-poppyHover2.png`,
    twitchStats202601v3: `${CDN_BASE_URL}/twitchStats-2026.01v3.png`,
    twitchChart202601a: `${CDN_BASE_URL}/twitchChart-2026.01-a.svg`,
    twitchChart202601b: `${CDN_BASE_URL}/twitchChart-2026.01-b.svg`,
    blogKicked: `${CDN_BASE_URL}/blogKicked.png`,
    featureKickFromRoom: `${CDN_BASE_URL}/feature-kickFromRoom.png`,
    featurePlayerAccessMenu: `${CDN_BASE_URL}/feature-playerAccessMenu.png`,
    loonSVG: `${CDN_BASE_URL}/loon.svg`,
    loonPNG: `${CDN_BASE_URL}/loon.png`,
    loonLite: `${CDN_BASE_URL}/loonLite.png`,
    loonSimple001: `${CDN_BASE_URL}/loonSimple001.png`,
    loonSimple010: `${CDN_BASE_URL}/loonSimple010.png`,
    loonSimple025: `${CDN_BASE_URL}/loonSimple025.png`,
    loonSimple050: `${CDN_BASE_URL}/loonSimple050.png`,
    loonSimple100: `${CDN_BASE_URL}/loonSimple100.png`,
    blogLoons: `${CDN_BASE_URL}/blogLoons.png`,
    twitchStats202602v2: `${CDN_BASE_URL}/twitchStats-2026.02v2.png`,
    twitchStats202603: `${CDN_BASE_URL}/twitchStats-2026.03.png`,
    avatarAnimalsBase: `${CDN_BASE_URL}/avatarAnimals`,
    slopBucket: `${CDN_BASE_URL}/slopBucket3.png`,
    slopBucketScene: `${CDN_BASE_URL}/images/scenes/slopBucket3.png`,
    blogAdults2: `${CDN_BASE_URL}/blogAdults2.png`,
    edgywizardPortrait: `${CDN_BASE_URL}/edgyWizardAvatarFinal.png`,
    logoHoleFit: `${CDN_BASE_URL}/logoHoleFit.png`,
    docHomeMeme: `${CDN_BASE_URL}/docHomeMeme2.png`,
    gameLibraryCozy: `${CDN_BASE_URL}/gameLibraryCozy2.png`,
    twitchStats202604: `${CDN_BASE_URL}/twitchStats-2026.04.png`,
    beat5Network: `${CDN_BASE_URL}/beat5network.svg`,
    beat5NetworkTall: `${CDN_BASE_URL}/beat5networkTall.svg`,
    logoKick: `${CDN_BASE_URL}/logoKick.png`,
    logoYouTube: `${CDN_BASE_URL}/logoYouTube.png`,
    heroFriends: `${CDN_BASE_URL}/heroFriends.png`,
    heroHome: `${CDN_BASE_URL}/heroHome.png`,
    heroTeam: `${CDN_BASE_URL}/heroTeam.png`,
    twitchStats202605: `${CDN_BASE_URL}/twitchStats-2026.05v2.png`,
    twitchStats202606: `${CDN_BASE_URL}/twitchStats-2026.06.png`,
    loonsMenu: `${CDN_BASE_URL}/feature-loonsMenu.png`,
    loonsRapidReload: `${CDN_BASE_URL}/feature-loonsRapidReload.png`,
    featureRemovePlayer: `${CDN_BASE_URL}/feature-removePlayer.png`,
    featureCensorshipMenu: `${CDN_BASE_URL}/feature-censorshipMenu.png`,
    twitchStats202607: `${CDN_BASE_URL}/twitchStats-2026.07.png`,
    twitchStats202608: `${CDN_BASE_URL}/twitchStats-2026.08.png`,
    twitchStats202609: `${CDN_BASE_URL}/twitchStats-2026.09.png`,
    twitchStats202610: `${CDN_BASE_URL}/twitchStats-2026.10.png`,
    blogStats202609ShadyJob: `${CDN_BASE_URL}/blog-2026.09-stats-shady-job.jpg`,
    blogPitc: `${CDN_BASE_URL}/blogPitc.png`,
    blogAchievements: `${CDN_BASE_URL}/blogAchievements.png`,
};
//# sourceMappingURL=assets.js.map